export const LOGIN_USER = '@PROFILE/LOGIN_USER';
export const LOGIN_USER_SUCCESS = '@PROFILE/LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = '@PROFILE/LOGIN_USER_ERROR';

export const LOAD_DATA = '@PROFILE/LOAD_DATA';
export const LOAD_DATA_SUCCESS = '@PROFILE/LOAD_DATA_SUCCESS';
export const LOAD_DATA_ERROR = '@PROFILE/LOAD_DATA_ERROR';

export const SET_PC_LEVEL_SUCCEESS = `@PROFILE/SET_PC_LEVEL_SUCCEESS`;
export const SET_PC_STATUS_SUCCESS = `@PROFILE/SET_PC_STATUS_SUCCESS`;
export const SET_PIN_SUCCESS = `@PROFILE/SET_PIN_SUCCESS`;

export const LOGOUT_USER = '@PROFILE/LOGOUT_USER';

export const RESET_DATA = `@PROFILE/RESET_DATA`;
